






































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ErrorAlert from "@/utility/ErrorAlert";
import { appModule } from "@/store/modules/app";
@Component({})
export default class ModalBatalSoap extends Vue {
  @Prop() readonly value!: boolean;
  alasan = "";
  valid = true;

  get msg() {
    return appModule.msgTtd;
  }

  batal() {
    this.$emit("setBatalSoap", { alasan: this.alasan });
    this.show = false;
  }

  @Watch("show")
  changedShow(val) {
    if (!val) {
      this.alasan = "";
      appModule.addMsgTtd("");
    }
  }

  close() {
    this.show = false;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
